import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { finalize, catchError, of } from 'rxjs';
import { ApiStatus, VisualizationType } from 'src/app/core/constants/constants';
import { Submenu, ReformatObject } from 'src/app/core/interface/flow-builder.interface';
import { AutoMlService } from 'src/app/core/service/auto-ml.service';
import { FlowBuilderService } from 'src/app/core/service/flow-builder.service';
import { ConfirmAlertComponent } from 'src/app/shared/scad-widget/alerts/confirm-alert/confirm-alert.component';
import { SubSink } from 'subsink';

@Component({
  selector: 'app-target-node',
  templateUrl: './target-node.component.html',
  styleUrls: ['./target-node.component.scss']
})
export class TargetNodeComponent {

  visualizeTypes:any = VisualizationType;
  searchTerm:string='';

  
  chartType = [
    {id: 1, name: 'Line chart'},{id: 2, name: 'Bar chart', disabled: true},
    {id: 3, name: 'Pie chart', disabled: true},{id: 3, name: 'Tree map', disabled: true},
    {id: 3, name: 'Scatter plot', disabled: true}
  ];
  isVisualizationBoard:boolean=false;
  publishToIFP:boolean=false;
  carDetailId:any;

  destinationType:any[] = [
    {
      name:'Publish Data to IFP',
      img:'assets//images/svg/windows.svg',
      click:()=>{
        this.onPublishSumbit('p')
      },
      isLoad:false
    },
    {
      name:'GDP Oracle DB',
      img:'assets/images/svg/oracle.svg',
      click: ()=>{}
    },
    {
      name:'Run AutoML',
      img:'assets/images/svg/auto-ml.svg',
      click: ()=>{
        this.autoMlProcess()
      },
      isLoad:false
    }
  ]

  destination = [
    {id: 1, name: 'destination1'},
    {id: 2, name: 'destination2'}
  ];


 
  selectedDestination: any;

  public inputKey: any;
  public outputKey: any;
  public inputConnection: any = [];
  public outputConnection: any = [];
  public next: any;
  public previous: any;
  public formData: any = new FormData();
  subs:SubSink=new SubSink();

  constructor(
    public _flowBuilder: FlowBuilderService,
    private _router: Router,
    private _toast:ToastrService,
    private dialog: MatDialog,
    public _autoMl:AutoMlService
  ){}


  onPublishSumbit(type:string) {

    let inputCount = 0, outputCount = 0;
    this._flowBuilder?.drawnNodeList?.forEach((item: Submenu) => {

      // if (item?.name?.includes('Target')) {
      const ipVal = this._flowBuilder?.editor?.getNodeFromId(item.id)?.inputs;
      const opVal = this._flowBuilder.editor?.getNodeFromId(item.id)?.outputs;
      const inputKey = Object.values(ipVal);
      inputCount += inputKey.length;
      const outputKey = Object.keys(opVal);
      outputCount += outputKey.length;
      inputKey?.forEach((key: number | any) => {
        this.inputKey = key;
        this.inputConnection = ipVal?.input_1?.connections;
      });
      outputKey?.forEach((key: number | any) => {
        this.outputKey = key;
        this.outputConnection = opVal[key]?.connections;
      });

      // } else {
      //   this._toast.warning('Need to select a target node');
      // }
    });

    if (this._flowBuilder?.createdConnectionList?.length != inputCount ) {
      this._toast.warning('Please provide a connection');

    } else {
      this.dataToPublishApi(type);
    }
  }

  autoMlProcess(){
    this.destinationType[2].isLoad = true;
    this.onPublishSumbit('a');
    this._autoMl.isInput=true;
    this._autoMl.stepperOptions[0].step = true;
    // this.getFileUpload();
  }

  dataToPublishApi(type:string): void {
    this.formData?.delete(`source`);
    this.formData?.delete(`json_data`);
    this.formData?.delete(`workflow_identifier`);
    this.formData?.delete(`sample_size`);
    this.formData?.delete(`workflow_name`);
    let delimiterSymbol: string | null;
    let obj:any = {};
    const gridData:any = {};
    let json = {};

    this._flowBuilder?.drawnNodeList?.forEach((element: Submenu|any, index: number) => {
      const data = this._flowBuilder?.editor?.getNodeFromId(element?.id);

      if (this._flowBuilder?.sheetName?.key && element?.connection_type === 'csv') {
        delimiterSymbol = null;
      }

      if (Object.keys(data?.inputs).length == 0) {
        this.previous = [];
      } else {
        this.previous = Object.keys(data?.inputs).map((v: string) => data.inputs[v]?.connections.map((c: string | any) => c.node)
        );
      }

      if (data.class == 'Filter') {
        if (Object.keys(data.outputs?.output_1).length == 0) {
          this.next = '';
        } else {
          this.next = Object.keys(data?.outputs).map((v: string) => data.outputs[v]?.connections.map((c: string | any) => c.node));
        }

        if (Object.keys(data.outputs?.output_2).length == 0) {
          this.next = '';
        } else {
          this.next = Object.keys(data.outputs).map((v: string) => data.outputs[v]?.connections.map((c: string | any) => c.node)
          );
        }
      }

      if (Object.keys(data?.outputs).length == 0) {
        this.next = '';
      } else {
        this.next = Object.keys(data?.outputs).map((v: string) => data.outputs[v]?.connections.map((c: string | any) => c.node)
        );
      }

      const key:any[] = [];
      const value:any[] = [];

      if (element?.name === 'Select') {
        if (!element['tempData']) {
          element['tempData'] = {};
        }
        element?.reFormat.forEach((selData: ReformatObject) => {
          if (selData?.checked == true) {
            key.push(selData?.originalName);
          }
          if (selData?.updatedName == null && selData?.checked == true) {
            value.push(selData?.originalName);
          } else if (selData?.updatedName != null && selData?.checked == true) {
            value.push(selData?.updatedName);
          }
        });
        for (let i = 0; i < key.length && i < value.length; i++) {
          gridData[key[i]] = value[i];
          element['tempData'][key[i]] = value[i];
        }
      }

      if (element?.name === 'Filter') {
        element?.filterFormat.forEach((xx: { key: any; }) => {
          key.push(xx.key);
        });
        for (let i = 0; i < key?.length; i++) {
          gridData[key[i]] = key[i];
        }
      }

      const union:any[] = [];
      if (element?.name === 'Union') {

        element.connection?.unionData?.forEach((unData: string) => {
          union.push(...unData);

        });

      }

      const leftJoin:any[] = [];
      const leftValue:any[] = [];
      const rightJoin:any[] = [];
      const rightValue:any[] = [];
      const leftData:any = {};
      const rightData:any = {};

      if (this._flowBuilder?.timeStamp == null) {
        const timestamp = new Date().getTime();
        this._flowBuilder.timeStamp = timestamp;
      }

      if (element?.name === 'Join') {
        element?.LeftJoinFormat?.forEach((lft_data: { checked: boolean; key: any; letfUpdatedName: any; }) => {
          if (lft_data.checked == true) {
            leftJoin.push(lft_data.key);
          }
          if (lft_data?.letfUpdatedName == null && lft_data?.checked == true) {
            leftValue.push(lft_data?.key);
          } else if (lft_data?.letfUpdatedName != null && lft_data?.checked == true) {
            leftValue.push(lft_data?.letfUpdatedName);
          }
        });
        for (let i = 0; i < leftJoin.length && i < leftValue.length; i++) {
          leftData[leftJoin[i]] = leftValue[i];
        }
        element?.RightJoinFormat?.forEach((right_data: { checked: boolean; key: any; rightUpdatedName: any; }) => {
          if (right_data?.checked == true) {
            rightJoin.push(right_data.key);
          }
          if (right_data?.rightUpdatedName == null && right_data.checked == true) {
            rightValue.push(right_data.key);
          } else if (right_data?.rightUpdatedName != null && right_data.checked == true) {
            rightValue.push(right_data.rightUpdatedName);
          }
        });
        for (let i = 0; i < rightJoin.length && i < rightValue.length; i++) {
          rightData[rightJoin[i]] = rightValue[i];
        }
      }

      const next:any = Object.values(this.next);
      const previous = Object.values(this.previous).map((v: any) => v.toString());

      if (element?.name == 'Source') {


        obj[element?.id] = {
          'fileKey': `Source${[index + 1]}`,
          'next': next.toString(),
          'node': element?.name.toLowerCase(),
          'previous': previous,
          'type': this._flowBuilder.fileType,
          'delimeter': delimiterSymbol
        };
        this.formData.append(`source`, element?.connection?.file);
      } else if (element?.name === 'Select') {

        obj[element?.id] = {
          'next': next.toString(),
          'node': element?.name.toLowerCase(),
          'previous': previous
        };
        obj[element?.id]['fields'] = element['tempData'];

      } else if (element?.name == 'Filter') {

        let nxtTrue:any = null;
        let nxtFalse:any = null;

        if (next[0] == null && next[1] != null) {
          nxtTrue = null;
          nxtFalse = Object.values(next[1]);
        } else if (next[0] != null && next[1] != null) {
          nxtTrue = Object.values(next[0]);
          nxtFalse = Object.values(next[1]);
        }

        const ftrName = element?.selectedFilter;
        const ftrOperator = element?.operator;
        const ftrValue = element?.value;
        obj[element?.id] = {
          'basic_condition': {
            'filter_field': ftrName || null,
            'filter_operator': ftrOperator || null,
            'filter_value': ftrValue || null
          },
          'custom_conditions': null,
          'true': {
            'next': nxtTrue.toString() || null
          },
          'false': {
            'next': nxtFalse.toString() || null
          },
          'node': element.name?.toLowerCase(),
          'previous': previous
        };
      } else if (element?.name === 'Join') {

        let joinFields = null;
        let inJoinFields = null;
        let rightJoinFields = null;

        if (data.outputs['output_1']?.connections?.length > 0) {
          joinFields = {
            'left': true,
            'next': next[0].toString()
          };
        }
        if (data?.outputs['output_2']?.connections?.length > 0) {
          inJoinFields = {
            'inner': true,
            'next': next[1].toString()
          };
        }
        if (data.outputs['output_3']?.connections?.length > 0) {
          rightJoinFields = {
            'right': true,
            'next': next[2].toString()
          };
        }
        obj[element?.id] = {

          'fields': { 'left': leftData, 'right': rightData },
          'left': joinFields,
          'on': {
            'left': element?.leftData,
            'right': element?.rightData
          },
          'right': rightJoinFields,
          'node': element.name?.toLowerCase(),
          'inner': inJoinFields,
          'previous': previous
        };
      } else if (element?.name === 'Union') {
        obj[element?.id] = {
          'node': element?.name?.toLowerCase(),
          'previous': previous,
          'order': union,
          'next': next.toString()
        };
      } else if (element?.name === 'Destination') {

        obj[element?.id] = {
          'name': 'dest_'+this._flowBuilder?.timeStamp,
          'node': 'target',
          'type': 'mysql',
          'connection_details':{
            "host":"3.111.235.245",
            "port":"3306",
            "database":"Scad_ETL_Local",
            "table_name":"test_data_"+this._flowBuilder.timeStamp,
            "user":"auraa_app",
            "password":"$4cC#BOJ0rS#"
          },
          'previous': previous
        };
        delete obj[element?.id].fields;
        delete obj[element?.id].next;
      }

      json = JSON.stringify(obj);

    });

    if (this._flowBuilder?.timeStamp == null) {
      const timestamp = new Date().getTime();
      this._flowBuilder.timeStamp = timestamp;

    }

    // if (this._flowBuilder?.saveName === null) {
    //   this._toast.warning('Add data source name');
    // } else {
      this.formData.append('json_data', json);
      this.formData.append('workflow_identifier', this._flowBuilder?.timeStamp);
      this.formData.append('workflow_name', 'dest_'+this._flowBuilder?.timeStamp);
      this.PublishApi(this.formData,type);
      // this.apiLoadingPublish = true;
    // }

  }

  async PublishApi(formData: FormData,type:string) {
    // const actionData = {
    //   action: 'delete',
    //   title: 'You are About to Publish the flow,',
    //   sub:'Are you sure?',
    //   cancelActionLabel: 'Cancel',
    //   okActionLabel: 'Yes'
    // }

    // const dialogRef = this.dialog.open(ConfirmAlertComponent, {
    //   width: '450px',
    //   data: actionData
    // });

    // dialogRef.afterClosed().subscribe((res:any)=>{
    //   if(res){
      if(type==='p'){
        this.destinationType[0].isLoad = true;
      }
        this._flowBuilder.FlowBuilderPublishApi(formData)
        .pipe(
          finalize(()=>{
            if(type==='p'){
              this.destinationType[0].isLoad = false;
              setTimeout(() => {
                this.getTableDetails();
              }, 1000);
            }else{
              setTimeout(() => {
                this.getFileUpload();
              }, 1000);
            }
          }),
          catchError((err:any) => {
            return of(false)
          })
        )
        .subscribe((res:any) => {

        if (res.message === 'success') {
          // this.apiLoadingPublish = false;
          // this._toast.success('Published Successfully');
          this._flowBuilder.showPreviewSection = false;
          // setTimeout(() => {
          //   this.getTableDetails();
          // }, 1000);
        } else {
          // this.apiLoadingPublish = false;
          this._toast.warning('Something went wrong');
        }
      });

        // this.selectedXAxis = '';
        // this.selectedYAxis = '';
        // this._flowBuilder.visualizeTitle = '';
        // this._flowBuilder.visualizeCharge = 0;
        // this._flowBuilder.visualizeDescription = '';
        // this._flowBuilder.graphLineData?.line_chart


    //   }
    // })

    // if (submit){
    //   this._analytics.FlowBuilderPublishApi(formData).subscribe((res:{status:number, message:string}) => {
    //     if (res?.status === ApiStatus.ok) {
    //       this.apiLoadingPublish = false;
    //       this._toast.success(res?.message);
    //       this.router.navigate(['/analytics/work-flow']);
    //     } else {
    //       this.apiLoadingPublish = false;
    //       this._toast.warning(res?.message);
    //     }
    //   });
    // }
  }

  getTableDetails(){
    this.subs.add(
      this._flowBuilder.getTableDetails("test_data_"+this._flowBuilder.timeStamp)
      .subscribe((res:any)=>{
        if(res){
          this._flowBuilder.selectedAxisValues = res;
          this._flowBuilder.isPublishToIfp = true
        }
      })
    )
  }

  getFileUpload(){
    const data ={
      file_id: this._flowBuilder.timeStamp.toString()
      // file_id: '1700143664907'
    }
    this.subs.add(
      this._autoMl.fileUpload(data)
      .pipe(
        finalize(()=>{
          this._autoMl.isAutoMl = true;
          // this._router.navigateByUrl('flow-builder/auto-ml')
          this._autoMl.getTableColums();
        })
      )
      .subscribe((res:any)=>{
      })
    )
  }


  getCardCharge(){
    const xAxis = this._flowBuilder.selectedXAxis;
    const yAxis = this._flowBuilder.selectedYAxis;
    this.subs.add(
      this._flowBuilder.getCardCharges("test_data_"+this._flowBuilder.timeStamp,xAxis,yAxis)
      .subscribe((res:any)=>{
        this._flowBuilder.visualizeCharge = res?.value;
        this._flowBuilder.visualizeComparison = res?.comparison_result;
      })
    )
  }


  saveVisualisation(){
    this._flowBuilder.showPreviewSection =false
    if ((this._flowBuilder.selectedXAxis === undefined) || (this._flowBuilder.selectedYAxis === undefined) || (this._flowBuilder.selectedType === undefined)){
      this._toast.warning('Add Values');
    } else {

      if(this.carDetailId){
        this.updateVisualisation();
        return
      }
      const formData: any = new FormData();
      formData.append('visualization_type', this._flowBuilder.visualizeType);
      formData.append('description', this._flowBuilder.visualizeDescription);
      formData.append('title', this._flowBuilder.visualizeTitle);
      formData.append('destination_board', '');
      formData.append('chart_type', this._flowBuilder.selectedType.name);
      formData.append('x_axix', this._flowBuilder.selectedXAxis);
      formData.append('y_axis', this._flowBuilder.selectedYAxis);
      formData.append('table_name', "test_data_"+this._flowBuilder.timeStamp);

      this.subs.add(
        this._flowBuilder.createTableForGraph(formData)
        .subscribe((res:any)=>{
          if (res?.status === ApiStatus.ok) {
            this._toast.success(res?.message);
            this._flowBuilder.isLong = false;
            this.getGraphTableDetail();
          } if (res?.status === ApiStatus.failed){
            this._toast.warning(res?.message);
          }
        }, (err:any) =>{
            if (err.error.status === ApiStatus.failed){
              this._toast.error(err.error?.message);
            }
        })
      )

    }
  }

  updateVisualisation(){
    this._flowBuilder.showPreviewSection =false
    if ((this._flowBuilder.selectedXAxis === undefined) || (this._flowBuilder.selectedYAxis === undefined) || (this._flowBuilder.selectedType === undefined)){
      this._toast.warning('Add Values');
    } else {
      const formData: any = new FormData();
      formData.append('visualization_type', this._flowBuilder.visualizeType);
      formData.append('description', this._flowBuilder.visualizeDescription);
      formData.append('title', this._flowBuilder.visualizeTitle);
      formData.append('destination_board', '');
      formData.append('chart_type', this._flowBuilder.selectedType.name);
      formData.append('x_axix', this._flowBuilder.selectedXAxis);
      formData.append('y_axis', this._flowBuilder.selectedYAxis);
      formData.append('table_name', "test_data_"+this._flowBuilder.timeStamp);

      this.subs.add(
        this._flowBuilder.updateTableForGraph(formData,this.carDetailId)
        .subscribe((res:any)=>{
          if (res?.status === ApiStatus.ok) {
            this._toast.success(res?.message);
            this._flowBuilder.isLong = false;
            this._flowBuilder.graphUpdate('update');
          } if (res?.status === ApiStatus.failed){
            this._toast.warning(res?.message);
          }
        }, (err:any) =>{
            if (err.error.status === ApiStatus.failed){
              this._toast.error(err.error?.message);
            }
        })
      )

    }
  }


  getGraphTableDetail(){
    this.subs.add(
      this._flowBuilder.getGraphTableDetail("test_data_"+this._flowBuilder.timeStamp)
      .subscribe((res:any)=>{
        this._flowBuilder.visualizeTitle = res[0].title;
        this._flowBuilder.visualizeDescription = res[0].description;
        this.carDetailId = res[0].id
      })
    )
  }





}
